import { CustomNode } from '../../../types';
import { sendSMSIcon } from '../../../icons';

const DEFAULT_ICON = sendSMSIcon;

export const sendSMSConfig: CustomNode = {
  getNodeConfig() {
    return {
      icon: DEFAULT_ICON,
    };
  },
};
